import React from "react";
import { Card, NumField, inr, unitPrice } from "./PricingUi";

// Kling v3 Pro ≈ $0.14/s and Seedance Fast ≈ $0.02/s of your Emergent balance (≈ 0.7 and 0.1 Emergent credits per second).
export const VideoCreditsCard = ({ p, set }) => {
  const unit = unitPrice(p.base_cost_inr, p.markup_pct);
  const per5 = (rate) => Math.ceil(Number(rate || 0) * 5);
  return (
    <Card title="Video studio" testid="pricing-video-card"
      desc="Customers pay for each second of AI video they create. Cinematic clips use about 0.7 of your Emergent credits per second, fast clips about 0.1. Editing, captions and making the final video are free.">
      <div className="grid sm:grid-cols-3 gap-4">
        <NumField label="Fast clips, per second" suffix="credits" step={0.1} value={p.video_fast_per_sec} onChange={(v) => set({ video_fast_per_sec: v })}
          testid="pricing-video-fast" hint={`A 5-second clip costs ${per5(p.video_fast_per_sec)} credits · ${inr(unit * per5(p.video_fast_per_sec))}`} />
        <NumField label="Cinematic clips, per second" suffix="credits" step={0.1} value={p.video_cinematic_per_sec} onChange={(v) => set({ video_cinematic_per_sec: v })}
          testid="pricing-video-cinematic" hint={`A 5-second clip costs ${per5(p.video_cinematic_per_sec)} credits · ${inr(unit * per5(p.video_cinematic_per_sec))}`} />
        <NumField label="Background music track" suffix="credits" value={p.music_credits} onChange={(v) => set({ music_credits: v })}
          testid="pricing-music-credits" hint={`${inr(unit * Number(p.music_credits || 0))} per track`} />
      </div>
    </Card>
  );
};

export default VideoCreditsCard;
